import type { InstrumentDto } from "../shared/contracts.ts";

export type InstrumentGroupKey = "share" | "bond" | "futures" | "other";

export const INSTRUMENT_GROUPS: readonly { key: InstrumentGroupKey; label: string }[] = [
  { key: "share", label: "Акции" },
  { key: "bond", label: "Облигации" },
  { key: "futures", label: "Фьючерсы" },
  { key: "other", label: "Прочее" },
];

export function instrumentGroupKey(instrumentType: string): InstrumentGroupKey {
  const type = instrumentType.replace(/^INSTRUMENT_TYPE_/i, "").toLowerCase();
  if (type.includes("share") || type.includes("stock")) return "share";
  if (type.includes("bond")) return "bond";
  if (type.includes("future")) return "futures";
  return "other";
}

function isInstrument(value: unknown): value is InstrumentDto {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const candidate = value as Partial<InstrumentDto>;
  return typeof candidate.uid === "string" && candidate.uid.length > 0 &&
    typeof candidate.ticker === "string" &&
    typeof candidate.name === "string" &&
    typeof candidate.instrumentType === "string" &&
    typeof candidate.lot === "number" && Number.isFinite(candidate.lot);
}

export function dedupeInstruments(instruments: InstrumentDto[]): InstrumentDto[] {
  return [...new Map(instruments.map((instrument) => [instrument.uid, instrument])).values()];
}

export function parseWatchlist(value: string | null): InstrumentDto[] | undefined {
  if (value === null) return undefined;
  try {
    const parsed = JSON.parse(value) as unknown;
    if (!Array.isArray(parsed) || !parsed.every(isInstrument)) return undefined;
    return dedupeInstruments(parsed).slice(0, 200);
  } catch {
    return undefined;
  }
}

export function watchlistSignature(instruments: InstrumentDto[]): string {
  return instruments.map((instrument) => instrument.uid).join("\u001f");
}
